import { Recipe } from "@/pages/sy/models/Recipe";
import {
  Box,
  Button,
  Dialog,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ChargeLayer } from "@/pages/sy/models/ChargeLayer";
import { chargeOperationStyles } from "@/pages/sy/styles/ChargeOperationStyles";
import { useTheme } from "@mui/material/styles";

export const RecipeModal = ({
  recipes,
  totalWeight,
  chargeLayers,
  isRecipeDialogOpen,
  setIsRecipeDialogOpen,
  selectedRecipeId,
  setSelectedRecipeId,
  setShowRecipeConfirmModal,
  handleRecipeSelect,
  handleCloseRecipeDialog,
}: {
  recipes: Recipe[];
  totalWeight: number;
  chargeLayers: ChargeLayer[];
  isRecipeDialogOpen: boolean;
  setIsRecipeDialogOpen: (isRecipeDialogOpen: boolean) => void;
  selectedRecipeId: number | null;
  setSelectedRecipeId: (selectedRecipeId: number | null) => void;
  setShowRecipeConfirmModal: (ihowRecipeConfirmModal: boolean) => void;
  handleRecipeSelect: (recipeId: number) => void;
  handleCloseRecipeDialog: (save: boolean) => void;
}) => {
  const theme = useTheme();
  const styles = chargeOperationStyles(theme);

  const [initialSelectedRecipeId, setInitialSelectedRecipeId] =
    useState(selectedRecipeId);

  useEffect(() => {
    setInitialSelectedRecipeId(selectedRecipeId);
  }, [isRecipeDialogOpen]);

  return (
    <Dialog
      open={isRecipeDialogOpen}
      onClose={() => handleCloseRecipeDialog(false)}
      maxWidth="md"
      slotProps={{
        paper: {
          sx: styles.dialogPaper,
        },
      }}
    >
      <Box sx={styles.dialogHeader}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Select Recipe
        </Typography>
      </Box>

      <Box sx={styles.dialogContent}>
        <List>
          {recipes
            .filter((recipe) => recipe.IsEnable)
            .map((recipe) => (
              <ListItem key={recipe.RecipeId} disablePadding>
                <ListItemButton
                  sx={{
                    ...(styles.recipeItem as object),
                    ...(recipe.RecipeId === selectedRecipeId
                      ? (styles.selectedRecipeItem as object)
                      : {}),
                  }}
                  onClick={() => setSelectedRecipeId(recipe.RecipeId as number)}
                >
                  <Typography sx={styles.recipeText}>
                    {recipe.RecipeName}
                  </Typography>
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      </Box>

      <Box
        sx={{ ...(styles.buttonsContainer as object), display: "flex", pb: 2 }}
      >
        <Button
          variant="contained"
          color="inherit"
          onClick={() => handleCloseRecipeDialog(false)}
          sx={styles.actionButton}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            if (selectedRecipeId === initialSelectedRecipeId) {
              handleCloseRecipeDialog(false);
              return;
            }

            if (chargeLayers.length > 1 && totalWeight > 0) {
              setShowRecipeConfirmModal(true);
            } else {
              if (selectedRecipeId) {
                handleRecipeSelect(selectedRecipeId);
              }
            }
            setIsRecipeDialogOpen(false);
          }}
          sx={styles.actionButton}
          disabled={!selectedRecipeId}
        >
          Save
        </Button>
      </Box>
    </Dialog>
  );
};
